import { Button, Icon } from '@design';
import { SplashLoader } from '@terminal/components/splash-loader/SplashLoader';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import styles from './ScenarioLoader.module.scss';

export const ASSETS_NUMBERS_WARNINGS = 500;

export interface ScenarioLoaderProps {
  countEntities: number;
  onAbort: () => void;
  onEditAssets?: () => void;
  conditionsCount?: number;
}

export const ScenarioLoader = ({
  countEntities,
  onAbort,
  conditionsCount,
}: ScenarioLoaderProps) => {
  const { t } = useTranslation(['scenario', 'common']);

  const [isOpen, setIsOpen] = useState(true);

  const keys = ['pastEpisodes', 'analyzing', 'evaluating'];
  const labels = keys.map(key =>
    /* i18next-extract-mark-context-next-line  ["pastEpisodes", "analyzing", "evaluating"] */
    t('scenario:scenarioLoader', { context: key })
  );

  // duration based on number of conditionsCount with minimum of 2s, distribute across 3 bars
  const ProgressBarDuration = Math.max((conditionsCount ?? 0) * 3000, 2000);

  const loader = (
    <SplashLoader
      className={styles.styledSplashLoader}
      data-testid="scenario-loading"
      labels={labels}
      isScenario
      duration={ProgressBarDuration}
    />
  );

  if (countEntities < ASSETS_NUMBERS_WARNINGS) {
    return <div className={styles.container}>{loader}</div>;
  }

  return (
    <div className={styles.container}>
      {isOpen && (
        <div
          className={styles.warningContainer}
          data-testid="scenario-loading-warning"
        >
          <div>
            <Icon
              iconName="InformationLightCircle"
              size={20}
              fillColor="var(--icon-primary)"
            />
          </div>
          <div className={styles.descriptionWrapper}>
            <div className={styles.headerWrapper}>
              <div className={styles.warningTitle}>{`${t(
                'scenario:warning.title'
              )} 🚀`}</div>
              <button
                type="button"
                className={styles.close}
                data-testid="warning-close-button"
                onClick={() => setIsOpen(false)}
                aria-label={t('common:close')}
              >
                <Icon iconName="Close" size={13} />
              </button>
            </div>
            <div className={styles.warningTextContent}>
              <Trans
                i18nKey={'scenario:warning.content'}
                components={[
                  <>
                    <br />
                    <br />
                  </>,
                ]}
              />
            </div>
            <Button
              label={t('scenario:warning.btnLabel')}
              variant="tertiary"
              size="small"
              onClick={onAbort}
            />
          </div>
        </div>
      )}
      {loader}
    </div>
  );
};
